import Quotation from '../../resource_models/quotation'

export const isLoading = (state) => {
  return state.isCallingAPI
}

export const all = (state) => {
  return state.result.map((id) => new Quotation(state.entities[id]))
}

export const find = (state) => (id) => {
  return new Quotation(state.entities[id])
}

export const meta = (state) => {
  return state.meta
}

export const errors = (state) => {
  return state.errors
}
